import React from 'react';
import { LANDING } from '@/constants/testIds';

const steps = [
    {
        title: 'Create your account',
        body: 'Sign up with email — no friction. Your data is yours.',
    },
    {
        title: 'Build your program',
        body: 'Add workouts and assign exercises day by day.',
    },
    {
        title: 'Log your sessions',
        body: 'Record sets, reps, and weights as you train.',
    },
    {
        title: 'Track your body',
        body: 'Log measurements weekly to see real change.',
    },
    {
        title: 'Watch yourself grow',
        body: 'Analytics and PRs show your progress over time.',
    },
];

export const HowItWorks = () => {
    return (
        <section
            id="how"
            data-testid={LANDING.howItWorksSection}
            className="relative py-28 sm:py-36 border-y border-white/5"
        >
            <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0a0a] to-black pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
                <div className="max-w-3xl mb-16">
                    <div className="text-xs uppercase tracking-[0.25em] text-[#b8ff00] font-semibold mb-4">
                        — How it works
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.02]">
                        Five steps. Zero fluff.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-3">
                    {steps.map((s, i) => (
                        <div
                            key={s.title}
                            data-testid={LANDING.step(i + 1)}
                            className="surface-card p-6 relative flex flex-col"
                        >
                            <div className="text-5xl font-extrabold text-[#b8ff00] font-display leading-none mb-5">
                                {String(i + 1).padStart(2, '0')}
                            </div>
                            <h4 className="text-white text-base font-semibold mb-2 leading-snug">
                                {s.title}
                            </h4>
                            <p className="text-sm text-[#8e8e93] leading-relaxed">
                                {s.body}
                            </p>
                            {/* Connector dot (desktop) */}
                            {i < steps.length - 1 && (
                                <div className="hidden lg:block absolute top-1/2 -right-3 w-2 h-2 rounded-full bg-[#b8ff00]/40" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
